"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenerationEventSchema = exports.GenerationEventKind = void 0;
const z = require("zod");
const implementation_rules_history_event_1 = require("./implementation-rules-history-event");
var GenerationEventKind;
(function (GenerationEventKind) {
    GenerationEventKind["ImplementationRules"] = "implementation_rules";
})(GenerationEventKind || (exports.GenerationEventKind = GenerationEventKind = {}));
exports.GenerationEventSchema = z.discriminatedUnion('kind', [
    z
        .object({
        kind: z.literal(GenerationEventKind.ImplementationRules),
        event: implementation_rules_history_event_1.ImplementationRulesHistoryEventSchema,
    })
        .strict(),
]);
//# sourceMappingURL=generation-event.js.map